export const CURRENCY_SYMBOL = "₹";


export const APP_NAME = "Jiboomba";
